import React from 'react';
import {
  Box,
  FormControlLabel,
  makeStyles,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@material-ui/core';
import { theme } from 'theme';
import { TPickupTimeType } from 'features/cart/types/CartTypes';
import moment from 'moment';
import { checkDateIsHolidaySurcharge, isPickup, isRestaurantOpen } from 'submodules/OrderCore';
import { IRestaurant, TTableId } from 'features/home/types/homeTypes';
import { Alert } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';

interface DateTimeComponentProps {
  pickupTimeType: TPickupTimeType;
  setPickupTimeType: (value: TPickupTimeType) => void;
  setPickupTime: (value: string) => void;
  setSelectedDate: (value: string) => void;
  validates: any;
  pickupTime: string;
  selectedDate: string;
  tableId: TTableId;
  restaurant: IRestaurant;
}

function DateTimeComponent({
  pickupTimeType,
  setPickupTimeType,
  setPickupTime,
  setSelectedDate,
  validates,
  pickupTime,
  selectedDate,
  tableId,
  restaurant,
}: DateTimeComponentProps) {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleChange = (event: any) => {
    if (event.target) {
      setPickupTimeType(event.target.value);
    }
  };

  const onChangeTime = (value) => {
    if (value.target) {
      setPickupTime(value.target.value);
    }
  };

  const onChangeDate = (value) => {
    if (value.target) {
      setSelectedDate(value.target.value);
    }
  };

  return (
    <Box>
      <Typography className={classes.title}>{t('Choose time')}</Typography>
      <RadioGroup
        aria-label="chooseTimeGroup"
        name="chooseTimeGroup"
        className={classes.radioGroup}
        value={pickupTimeType}
        onChange={handleChange}
      >
        {isRestaurantOpen(restaurant, null, null) && (
          <FormControlLabel value="now" control={<Radio size="medium" />} label="Now" />
        )}

        <FormControlLabel value="chooseTime" control={<Radio />} label="Choose time" />
      </RadioGroup>
      {pickupTimeType === 'chooseTime' && (
        <Box display="flex">
          <TextField
            error={
              validates.pickupTime &&
              pickupTime === '' &&
              (pickupTimeType === 'chooseTime' || isPickup(tableId))
            }
            onChange={onChangeTime}
            id="time"
            label="Choose time"
            type="time"
            defaultValue={moment().format('HH:mm')}
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              step: 60,
            }}
          />

          <TextField
            error={validates.selectedDate && selectedDate === ''}
            onChange={onChangeDate}
            id="date"
            label="Choose time"
            type="date"
            defaultValue={moment().format('YYYY-MM-DD')}
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
      )}
      {pickupTimeType === 'chooseTime' && checkDateIsHolidaySurcharge(restaurant, selectedDate) && (
        <Box className={classes.alertBusyMode}>
          <Alert severity="info">
            {t('Please note a holiday surcharge of', {
              chargeName: `${restaurant.holidaySurcharge.name}`,
              amount: `${restaurant.holidaySurchargeSettings.amount}%`,
            })}
          </Alert>
        </Box>
      )}
    </Box>
  );
}

const useStyles = makeStyles({
  title: {
    fontSize: 14,
    lineHeight: '2.4rem',
    color: theme.palette.text.secondary,
  },
  textField: {
    flex: 1,

    '&:first-child': {
      marginRight: 20,
      marginBottom: 20,
    },

    '& div': {
      color: theme.palette.text.secondary,
    },

    '& input': {
      borderBottom: `2px solid ${theme.palette.text.secondary}`,
    },
  },
  alertBusyMode: { margin: '20px 0' },
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 20,
    color: theme.palette.text.secondary,
  },
});

export default DateTimeComponent;
